export const steppLabels = ['Въпросник', 'Оферти', 'Собственик', 'Покупка'];